import React from "react";
import { ConfigProvider, Row, Col } from "antd";
import ar_EG from "antd/lib/locale/ar_EG";
import YearMonthFilter from "../../biblio/YearMonthFilter";

interface CustomConfigProviderProps {
  title: string;
  locale?: typeof ar_EG;
  children?: React.ReactNode;
  withdateFilter?: boolean;
  filterState?: any;
  setState?: (values: any) => void;
  fitlerdatewithTitle?: boolean;
  dateTitle?: string;
  bottomMargin?: number;
  YearValue?: string | "";
}

const CustomConfigProvider: React.FC<CustomConfigProviderProps> = ({
  title,
  locale = ar_EG,
  children,
  withdateFilter = false,
  filterState,
  setState,
  fitlerdatewithTitle = false,
  dateTitle = "",
  bottomMargin = null,
  YearValue,
}) => {
  return (
    <div style={{ marginBottom: bottomMargin ? bottomMargin + "rem" : "3rem" }}>
      <ConfigProvider locale={locale} direction="rtl">
        <Row gutter={16} dir="rtl" justify={"space-between"}>
          {children ? (
            <Col xxl={18} xl={18} lg={18} md={18} sm={24} xs={24}>
              <span className="takaful--service-section-title">{title}</span>
            </Col>
          ) : (
            <Col span={24}>
              <span className="takaful--service-section-title">{title}</span>
            </Col>
          )}
          <Col
            xxl={6}
            xl={6}
            lg={6}
            md={6}
            sm={24}
            xs={24}
            style={{ marginTop: "0.3rem" }}
          >
            {children}
          </Col>
        </Row>
        {withdateFilter && filterState && setState && (
          <YearMonthFilter
            state={filterState}
            setState={setState}
            title={dateTitle}
            withtitle={fitlerdatewithTitle}
            yearValue={YearValue}
          />
        )}
      </ConfigProvider>
    </div>
  );
};

export default CustomConfigProvider;
